// Libraries
import { logoutRequest } from '../../redux/common/auth/auth.actions';
import {
    getStaticDataRequest,
    fetchUnderlyingMerchantStaticRequest,
    fetStaticInfoRequest,
    fetchChargebackStaticRequest,
} from '../../redux/common/staticData/staticData.actions';
import axislogo from '../../static/images/fc-logo-01.png';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

// Actions

// Images

// Styles
import './header.scss';

const Header = props => {
    const { actions, auth, staticData } = props;
    const {
        staticInfo,
        payValues,
        underlyingMerchant,
        chargebackStaticInfo,
    } = staticData;

    const location = useLocation();

    useEffect(() => {
        if (auth.isLoggedIn) {
            if (isEmpty(payValues)) {
                actions.getStaticDataRequest();
            }
            if (isEmpty(underlyingMerchant)) {
                actions.fetchUnderlyingMerchantStaticRequest();
            }
            if (isEmpty(staticInfo)) {
                actions.fetStaticInfoRequest();
            }
            if (isEmpty(chargebackStaticInfo)) {
                actions.fetchChargebackStaticRequest();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth.isLoggedIn]);

    return (
        <div className="header">
            <div className="header-left">
                <Link to={location.pathname === '/login' ? '/login' : '/'}>
                    <img src={axislogo} alt="Axis Bank" />
                </Link>
            </div>
            <div className="header-right">
                {auth.isLoggedIn &&
                    location.pathname.indexOf('/resetpassword') < 0 && (
                        <button
                            className="header-actions"
                            style={{ color: '#ff7744', background: 'none', border: 'none', cursor: 'pointer' }}
                            onClick={() => actions.logoutRequest()}
                        >
                            Logout
                        </button>
                    )}
            </div>
        </div>
    );
};

const mapStateToProps = ({ auth, staticData }) => ({
    auth,
    staticData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            logoutRequest,
            getStaticDataRequest,
            fetchUnderlyingMerchantStaticRequest,
            fetStaticInfoRequest,
            fetchChargebackStaticRequest,
        },
        dispatch
    ),
});

Header.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    staticData: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
